import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useMediaQuery,
  useTheme,
  Grid,
  Container,
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'

const Navbar = () => {
  const navigate = useNavigate()
  const [isSticky, setIsSticky] = useState(false)
  const [drawerOpen, setDrawerOpen] = useState(false)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const handleScroll = () => {
    setIsSticky(window.scrollY > 50)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToSection = (id) => {
    const section = document.getElementById(id)
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' })
    }
    setDrawerOpen(false) // Close drawer after navigation
  }

  const toggleDrawer = () => {
    setDrawerOpen((prev) => !prev)
  }

  const navItems = [
    { label: 'Home', id: 'home' },
    { label: 'Features', id: 'features' },
    { label: 'Goal Tracker', id: 'goal-tracker' },
    { label: 'Project Insights', id: 'project-insights' },
    { label: 'Contact Us', id: 'contact-us' },
  ]

  return (
    <>
      {/* AppBar */}
      <AppBar
        position="fixed"
        color="inherit"
        elevation={isSticky ? 4 : 0}
        sx={{
          transition: 'all 0.3s ease-in-out',
          backgroundColor: isSticky ? 'white' : 'transparent',
          width: '100vw',
          overflowX: 'hidden',
        }}
      >
        <Container maxWidth="lg">
          <Toolbar className="p-0">
            <Grid container alignItems="center" justifyContent="space-between">
              {/* Logo */}
              <Grid item>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    src="/branding/e7_logo_black.png"
                    alt="epoch7 logo"
                    style={{ width: '109px', cursor: 'pointer' }}
                    onClick={() => scrollToSection('home')}
                  />
                </Box>
              </Grid>

              {/* Desktop Nav Items */}
              {!isMobile && (
                <Grid item>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                    {navItems.map((item) => (
                      <Button
                        key={item.id}
                        onClick={() => scrollToSection(item.id)}
                        color="inherit"
                      >
                        {item.label}
                      </Button>
                    ))}
                    <Button
                      className="btn primary-btn"
                      variant="contained"
                      onClick={() => navigate('/login')}
                      sx={{ textTransform: 'none' }}
                    >
                      Login
                    </Button>
                    <Button
                      className="btn secondary-btn"
                      variant="outlined"
                      onClick={() => navigate('/signup')}
                      sx={{ textTransform: 'none' }}
                    >
                      Company Signup
                    </Button>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Mobile Toggle Button (always visible) */}
      {isMobile && (
        <IconButton
          onClick={toggleDrawer}
          edge="end"
          sx={{
            position: 'fixed',
            top: 5,
            right: 20,
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: 'white',
          }}
        >
          <MenuIcon />
        </IconButton>
      )}

      {/* Mobile Drawer */}
      <Drawer
        className="mobile-list"
        anchor="top"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: {
            width: '100vw',
            maxWidth: '100vw',
            overflowX: 'hidden',
            backgroundColor: '#f9f9f9',
          },
        }}
      >
        <Box sx={{ mt: 2, p: 2 }}>
          {/* Logo inside Drawer */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
            <img
              src="/branding/e7_logo_black.png"
              alt="epoch7 logo"
              style={{ width: '109px', cursor: 'pointer', position: 'relative', top: '-16px' }}
              onClick={() => {
                scrollToSection('home')
                setDrawerOpen(false)
              }}
            />
          </Box>
          <List>
            {navItems.map((item) => (
              <ListItem key={item.id} disablePadding>
                <ListItemButton onClick={() => scrollToSection(item.id)}>
                  <ListItemText primary={item.label} />
                </ListItemButton>
              </ListItem>
            ))}
            <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Button
                variant="contained"
                className="btn primary-btn"
                onClick={() => {
                  navigate('/login')
                  setDrawerOpen(false)
                }}
                sx={{ textTransform: 'none' }}
              >
                Login
              </Button>

              <Button
                variant="outlined"
                className="btn secondary-btn"
                onClick={() => {
                  navigate('/signup')
                  setDrawerOpen(false)
                }}
                sx={{ textTransform: 'none' }}
              >
                Company Signup
              </Button>
            </Box>
          </List>
        </Box>
      </Drawer>
    </>
  )
}

export default Navbar
